export default "__VITE_ASSET__DGdCP7aB__"